import { GET_TASKS_RELATED_OPTION_LIST, RESET_TASKS_RELATED_OPTION } from '../actions/types';

const initialState = () => {
  return {
    list: []
  };
};

export default function(state = initialState(), action = {}) {
  switch (action.type) {
    case GET_TASKS_RELATED_OPTION_LIST: {
      return { ...state, ...{ list: action.tasksRelatedOptionData } };
    }
    case RESET_TASKS_RELATED_OPTION: {
      return { ...initialState() };
    }
    default:
      return state;
  }
}
